// extracted by mini-css-extract-plugin
module.exports = {"List":"List-module--List--15ajI","ListItem":"List-module--ListItem--1swCU"};